import * as React from "react";

type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className = "", ...props }, ref) => {
    const base =
      "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm " +
      "placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 " +
      "disabled:opacity-50";

    return <textarea ref={ref} className={`${base} ${className}`} {...props} />;
  }
);

Textarea.displayName = "Textarea";
